import { useCallback, useState } from "react";

import {
	DatePickerConnectFunctionType,
	datePickerValuesFromProps,
	datePickerValuesToProps,
} from "types";

const useDatePickerFromTo = () => {
	const [fromValue, setFromValue] = useState<{ [key: string]: any }>({});
	const [toValue, setToValue] = useState<{ [key: string]: any }>({});

	const datePickerValuesFrom = useCallback<DatePickerConnectFunctionType>(
		(connectionName = ""): datePickerValuesFromProps => ({
			setFromValue: value =>
				setFromValue({ ...fromValue, [connectionName]: value }),
			toValue: toValue[connectionName],
		}),
		[fromValue, toValue],
	);

	const datePickerValuesTo = useCallback<DatePickerConnectFunctionType>(
		(connectionName = ""): datePickerValuesToProps => ({
			setToValue: value =>
				setToValue({ ...toValue, [connectionName]: value }),
			fromValue: fromValue[connectionName],
		}),
		[fromValue, toValue],
	);

	return {
		datePickerValuesFrom,
		datePickerValuesTo,
	};
};

export default useDatePickerFromTo;
